<app-panel-select-for-simple-coat [product_type]="product_type" [job]="job" [coat]="coat" (onSubmit)="selected($event)" (onCancel)="cancel()"></app-panel-select-for-simple-coat>
